import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sc-autocomplete-field',
  templateUrl: './autocomplete-field.component.html',
  styleUrls: ['./autocomplete-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteFieldComponent),
      multi: true
    }
  ]
})
export class AutocompleteFieldComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() options: {
    fields: Observable<any>;
  };

  public filteredEntities: Observable<any[]>;
  public formControl: FormControl = new FormControl();

  private _appearance: MatFormFieldAppearance = 'standard';

  constructor() {}

  @Input() set appearance(appearance: MatFormFieldAppearance) {
    if (appearance) {
      this._appearance = appearance;
    }
  }

  get appearance(): MatFormFieldAppearance {
    return this._appearance;
  }

  onChange = (value: any) => {};
  onTouched = () => {};

  public ngOnInit() {
    this.filteredEntities = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => {
        const isString = typeof value === 'string';
        if (!isString && value) {
          this.writeValue(value.id);
        }

        return isString;
      }),
      switchMap(value => this.options.fields.pipe(map((fields: any[]) => this._filter(value, fields))))
    );
  }

  public writeValue(value: any) {
    this.formControl.setValue(value);
    this.onChange(value);
  }

  public displayFn(data: any) {
    const isString = typeof data === 'string';
    return isString ? data : data && data.name;
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private _filter(value: string, fields: any[]) {
    const filterValue = value.toLowerCase();
    return fields.filter(option => option['name'].toLowerCase().includes(filterValue));
  }
}
